import { useLogoutMutation } from '@websky/graphql';
import { useHistory } from '@shared/routing';
import * as Cookie from 'js-cookie';

import { GRAPHQL_KEY } from '../../cache';

export const useLogout = (replace?: string) => {
	const history = useHistory();

	const [logoutMutation, { loading }] = useLogoutMutation();

	const onLogout = async () => {
		try {
			Cookie.remove(GRAPHQL_KEY);

			await logoutMutation();

			if (replace) {
				history.replace(replace);
			}

			window.location.reload();
		} catch (e) {
			console.log(e);
		}
	};

	return { onLogout, loading };
};
